import { withReact } from 'slate-react';

import { BuiltInComponents } from 'craft/constants';
import typographyStyles from 'craft/resolvers/Typography/constants';
import { withId } from 'craft/rte/plugins/withId';

import { withInline } from './withInline';
import { withLink } from './withLink';
import { withList } from './withList';
import { withMarkdownShortcuts } from './withMarkdownShortcuts';
import { withTypography } from './withTypography';
import { withVoid } from './withVoid';

/**
 * note! the order of plugin matters. Insert the plugin with least dependencies at the bottom (they will get executed first)
 * and the ones with most dependencies on top.
 */
export default [
  withId(),
  withVoid([BuiltInComponents.Variable]),
  withInline([BuiltInComponents.Link, BuiltInComponents.Variable]),
  withMarkdownShortcuts,
  withList({
    typeLi: BuiltInComponents.ListItem,
    typeOl: BuiltInComponents.List,
    typeUl: BuiltInComponents.List,
    onDefault: () => ({
      type: BuiltInComponents.Typography,
      data: { variant: 'P', css: typographyStyles.P },
    }),
  }),
  withLink({ typeLink: BuiltInComponents.Link }),
  withTypography,
  withReact,
];
